import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow_left.svg';

export default function AuthBackHeader({ onBack }) {
  if (!onBack) return <div className="h-[37px] w-full shrink-0" />;

  return (
    <header className="flex h-[37px] w-full shrink-0 items-center px-[15px]">
      <button
        type="button"
        aria-label="뒤로"
        className="flex h-9 w-9 items-center justify-start border-0 bg-transparent p-0"
        onClick={onBack}
      >
        <ArrowIcon width={9} height={18} aria-hidden />
      </button>
    </header>
  );
}
